import { render, staticRenderFns } from "./statement.vue?vue&type=template&id=bb87ad52"
import script from "./statement.vue?vue&type=script&lang=js"
export * from "./statement.vue?vue&type=script&lang=js"
import style0 from "./statement.vue?vue&type=style&index=0&id=bb87ad52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports